"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { colors, mediaQueries, sizes } from "ui"

export const FormsAndActionsWrapper = styled(Box)`
  display: flex;
  width: 100%;
  gap: ${sizes.basePenta};
  border-radius: 30px;
  background-color: ${colors.white};
  ${mediaQueries.mobile} {
    flex-direction: column;
    border-radius: ${sizes.basePenta};
    padding: ${sizes.basePenta} ${sizes.baseTriple};
  }
  ${mediaQueries.tablet} {
    flex-direction: column;
    border-radius: ${sizes.basePenta};
    padding: ${sizes.basePenta} ${sizes.baseTriple};
  }

  ${mediaQueries.desktopM} {
    flex-direction: row;
    padding: ${sizes.basePenta} ${sizes.baseOcto};
    > * {
      border-inline-end: 1px solid ${colors.lightGray};
      &:last-child {
        border-inline-end: none;
      }
    }
  }
`

export const StyledLink = styled("a")`
  color: ${colors.black};
  text-decoration: underline;
  margin-top: auto;
  margin-inline-start: auto;
`
